export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.provide('getFormattedNumber', (number) => {
        return number?.toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    })
})